<ion-app>
    <ion-split-pane contentId="side-menu-content">
        <ion-menu contentId="side-menu-content" type="overlay">
            <ion-content>
                <div class="ion-text-center">
                    <img class="header-img-title" src="/assets/images/app-icon.png" alt="" />
                    <img src="/assets/logo.png" alt="" class="img-text-logo" />
                </div>
                <ion-list class="menu-list">
                    <ion-menu-toggle auto-hide="false">
                        <ion-item
                            detail="false"
                            lines="none"
                            routerLink="/sell-now/products"
                            routerDirection="root"
                            routerLinkActive="selected"
                        >
                            <ion-label>Produsele mele</ion-label>
                        </ion-item>
                    </ion-menu-toggle>
                    <ion-menu-toggle auto-hide="false">
                        <ion-item
                            [routerLinkActiveOptions]="{ exact: true }"
                            detail="false"
                            lines="none"
                            routerLink="/sell-now"
                            routerDirection="root"
                            routerLinkActive="selected"
                        >
                            <ion-label>Vinde Acum</ion-label>
                        </ion-item>
                    </ion-menu-toggle>

                    <ion-menu-toggle auto-hide="false">
                        <ion-item [detail]="false" lines="none" [button]="true" (click)="logoutAccount()">
                            <ion-label class="ion-text-wrap">
                                {{ 'SIGN_OUT' | translate }}
                            </ion-label>
                        </ion-item>
                    </ion-menu-toggle>
                </ion-list>
            </ion-content>
        </ion-menu>
        <ion-router-outlet id="side-menu-content"></ion-router-outlet>
    </ion-split-pane>
</ion-app>
